import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import reducer from "../reducers";
import { composeWithDevTools } from "redux-devtools-extension";
import { multiClientMiddleware } from "redux-axios-middleware";
import socketMiddleware from "utils/socketMiddleware";
import { clientV1, clientV2 } from "./agent";
import localforage from "localforage";
import { setAuthHeader } from "utils/setAuthHeader";

const persistConfig = {
	key: "root",
	version: 0,
	storage: localforage,
	stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, reducer);

const initStore = () => {
	const clients = {
		default: { client: clientV1 },
		v2: { client: clientV2 },
	};
	const middleware = [multiClientMiddleware(clients), socketMiddleware];
	let store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middleware)));
	let persistor = persistStore(store, null, () => {
		const state = store.getState();
		const token = state?.user?.session?.token;
		if (token) {
			setAuthHeader(token, 'both');
		}
	});

	return { store, persistor };
};

export default initStore;
